document.addEventListener('DOMContentLoaded', function () {
  const megaMenu = document.getElementsByClassName('mega-menu__content');

  [...megaMenu].forEach((element) => {
    element.addEventListener('click', (event) => {
      if (!event.target.classList.contains('mega-menu__link')) return;

      const currentMenuItem = element.querySelector('.menu--active');
      const currentSubMenu = element.querySelector('.sub-menu--active');
      const selectedSubMenu = event.target.parentElement.querySelector('div');

      // A rail item with no panel is a plain link: let the browser follow it.
      if (!selectedSubMenu || event.target === currentMenuItem) return;

      currentMenuItem?.classList.remove('menu--active');
      currentSubMenu?.classList.remove('sub-menu--active');
      event.target.classList.add('menu--active');
      selectedSubMenu.classList.add('sub-menu--active');
    });
  });
});
